import { startCoroutineUninterceptedOrReturnGeneratorVersion1r5yf56916wr4 as startCoroutineUninterceptedOrReturnGeneratorVersion } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function pipelineStartCoroutineUninterceptedOrReturn(interceptor, context, subject, continuation) {
  var coroutine = pipelineStartCoroutineUninterceptedOrReturn$slambda_0(interceptor, context, subject);
  // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
  return startCoroutineUninterceptedOrReturnGeneratorVersion(coroutine, continuation);
}
var pipelineStartCoroutineUninterceptedOrReturn$slambdaClass;
function pipelineStartCoroutineUninterceptedOrReturn$slambda() {
  if (pipelineStartCoroutineUninterceptedOrReturn$slambdaClass === VOID) {
    class $ {
      constructor($interceptor, $context, $subject) {
        this.c4y_1 = $interceptor;
        this.d4y_1 = $context;
        this.e4y_1 = $subject;
      }
      *j4p($completion) {
        yield* this.c4y_1(this.d4y_1, this.e4y_1, $completion);
        return Unit_instance;
      }
      nd($completion) {
        return this.j4p($completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    pipelineStartCoroutineUninterceptedOrReturn$slambdaClass = $;
  }
  return pipelineStartCoroutineUninterceptedOrReturn$slambdaClass;
}
function pipelineStartCoroutineUninterceptedOrReturn$slambda_0($interceptor, $context, $subject) {
  var i = new (pipelineStartCoroutineUninterceptedOrReturn$slambda())($interceptor, $context, $subject);
  var l = ($completion) => i.j4p($completion);
  l.$arity = 0;
  return l;
}
//region block: exports
export {
  pipelineStartCoroutineUninterceptedOrReturn as pipelineStartCoroutineUninterceptedOrReturn3fvxhza76tp2,
};
//endregion

//# sourceMappingURL=Pipeline.web.mjs.map
